import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 48
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {
          boxShadow: 'none'
        },
        containedSecondary: {
          boxShadow: 'none'
        },
        outlined: {
          borderWidth: 1.5,
          borderColor: theme.palette.grey[700],
          color: theme.palette.text.primary,
          '&:hover': {
            borderColor: theme.palette.grey[900],
            backgroundColor: alpha(theme.palette.grey[900], theme.alphas.subtle)
          }
        },
        outlinedPrimary: {
          borderWidth: 1.5,
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
          '&:hover': {
            borderColor: theme.palette.primary.dark,
            backgroundColor: alpha(theme.palette.primary.main, 0.06)
          }
        },
        outlinedSecondary: {
          borderWidth: 1.5,
          borderColor: theme.palette.secondary.main,
          color: theme.palette.secondary.main,
          '&:hover': {
            borderColor: theme.palette.secondary.dark,
            backgroundColor: alpha(theme.palette.secondary.main, 0.06)
          }
        },
        outlinedInherit: {
          borderWidth: 1.5,
          borderColor: theme.palette.grey[700],
          color: theme.palette.text.primary,
          '&:hover': {
            borderColor: theme.palette.grey[900],
            backgroundColor: alpha(theme.palette.grey[900], theme.alphas.subtle)
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  };
}
